import { render, staticRenderFns } from "./WritingTR.vue?vue&type=template&id=6e4a12e5&scoped=true&"
import script from "./WritingTR.vue?vue&type=script&lang=js&"
export * from "./WritingTR.vue?vue&type=script&lang=js&"
import style0 from "./WritingTR.vue?vue&type=style&index=0&id=6e4a12e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a12e5",
  null
  
)

export default component.exports